export default __webpack_public_path__ + "static/thebottomline19-1f5dcd00ef8d7f302ef1b6a0c6c81f3c.jpg";